import "./simpleSpinner.scss"

export const simpleSpinner = {
  template: `<span></span>`
}